import React from 'react'
import { isEmpty } from 'lodash'
import { Container, Alert } from '@paypalcorp/pp-react'

import { useApplicationContext } from '../../../../../provider'

import './style.css'

const NotificationBanner = ({ handleDismiss }) => {
  // Get the user context to see if logged in - we use this to control margin
  const { user } = useApplicationContext()
  const userLoggedOut = !isEmpty(user) && !user.loggedIn

  return (
    <section
      className={
        !userLoggedOut
          ? 'notification-banner notification-banner_loggedIn'
          : 'notification-banner'
      }
    >
      <Container className="banner-wrapper">
        <Alert
          type="warning"
          className="alert-banner"
          closeButton={{
            'aria-label': 'dismiss alert',
            onClick: () => handleDismiss(),
          }}
        >
          PayPal has been working closely with governments and partners to
          actively comply with all applicable laws and sanctions. Under the
          current circumstances, we are suspending PayPal services in Russia.
          This means we are suspending send or receive transaction services
          between Russia and other countries with PayPal. You will still be able
          to withdraw funds to a bank account.
        </Alert>
      </Container>
    </section>
  )
}

export default NotificationBanner
